export default __webpack_public_path__ + "static/media/IBKneeflexionatmidswing1.a3271600.png";